const moment = require('moment')

require('moment/locale/fr')
require('moment/locale/de')
require('moment/locale/en-gb')

moment.locale(navigator.language)

export default moment
